/**
 * project_templates.agent_id is profiles.id, never auth.uid() and never
 * the team owner's id unless the signed-in profile is that owner.
 * The insert policy matches profiles.user_id to auth.uid().
 */

function checklistTemplateFields(fields) {
  const source = fields || {};
  return {
    name: String(source.name || '').trim(),
    description: source.description || '',
    tasks: Array.isArray(source.tasks) ? source.tasks : [],
  };
}

function checklistTemplateInsert(profile, fields) {
  if (!profile || !profile.id) {
    const error = new Error('Missing agent profile');
    error.code = 'missing_agent';
    throw error;
  }
  const fieldsToSave = checklistTemplateFields(fields);
  return {
    agent_id: profile.id,
    name: fieldsToSave.name,
    description: fieldsToSave.description,
    tasks: fieldsToSave.tasks,
    is_global: false,
  };
}

module.exports = { checklistTemplateInsert, checklistTemplateFields };
